/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A VDK Web utility library. (@accedo/vdkweb-utils) 5.0.2
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WheelListener = _interopRequireDefault(require("./WheelListener"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function WheelSurface(_ref) {
  var style = _ref.style,
      onWheelDown = _ref.onWheelDown,
      onWheelUp = _ref.onWheelUp,
      onWheelLeft = _ref.onWheelLeft,
      onWheelRight = _ref.onWheelRight,
      options = _ref.options,
      children = _ref.children;

  var handleWheelEvent = function handleWheelEvent(_ref2) {
    var x = _ref2.x,
        y = _ref2.y;

    if (y > 0) {
      onWheelDown && onWheelDown();
    } else if (y < 0) {
      onWheelUp && onWheelUp();
    }

    if (x > 0) {
      onWheelLeft && onWheelLeft();
    } else if (x < 0) {
      onWheelRight && onWheelRight();
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_WheelListener["default"], _extends({
    style: style
  }, options, {
    onWheel: handleWheelEvent
  }), children);
}

WheelSurface.propTypes = {
  children: _propTypes["default"].node,
  onWheelDown: _propTypes["default"].func,
  onWheelLeft: _propTypes["default"].func,
  onWheelRight: _propTypes["default"].func,
  onWheelUp: _propTypes["default"].func,
  options: _propTypes["default"].object,
  style: _propTypes["default"].object
};
var _default = WheelSurface;
exports["default"] = _default;